<template>
  <div class="upload">
    <el-button
        v-if="!!uploadFileListCancel.length || currentFileList.length"
        type="warning" size="mini" class="cancel-btn"
        @click="()=>handleCancelUpload()"
    >
        取消上传
    </el-button>
    <el-upload
            drag
            action="#"
            class="upload-box"
            :http-request="handleHttpRequest"
            :show-file-list="false"
            multiple>
            <div class="upload-tip">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div 
                    v-for="item in noAllFileConfigList"
                    :key="item.id"
                    class="fiter-item"
                > {{ item.label }} </div>
             </div>
     </el-upload>
  </div>
</template>

<script>
import getMediaInfo from '@/libs/media';
import {  cloneDeep } from 'lodash'
export default {
    name: "Upload",
    props: [ 'fileConfigList', 'uploadFileListCancel', 'currentKey' ],
    inject: [ 'getKey', 'hasAll' ],
    data() {
        return {
            fileList: [],
            errFileList: [],
            lock: false,//加个锁 防止数据取值和赋值 错误
            num: 0
        }
    },
    computed: {
        noAllFileConfigList() {
            return this.fileConfigList.filter(v=> {
                return v.value !=='all'
            })
        }, 
        fileTypes() {
            return this.noAllFileConfigList.reduce((pre, item)=> {
                const list = item.conf_format.split('/');
                return pre.concat(list);
            }, [])
        },
        imageData() {
            return this.noAllFileConfigList.filter(v=>v.material_type ==='1').reduce((pre, item)=> {
                return this.getCommonData(pre, item);
            }, {})
        },
        videoData() {
            return this.noAllFileConfigList.filter(v=>v.material_type ==='3').reduce((pre, item)=> {
                const data = this.getCommonData(pre, item);
                    const time = item.conf_length;
                    // 获取大小
                    if (data.time) {
                        data.time.push(time)
                    } else {
                        data.time = [ time ]
                    };
                return data;
            }, {})
        },
        currentFileList() {
            return this.fileList.filter(v=> {
                return v.key === this.currentKey
            })
        }
     },
    methods: {
        handleCancelUpload() {
            this.fileList = this.fileList.filter(v=> {
                return v.key !== this.currentKey
            })
            this.$emit('cancelUpload')
        },
        getCommonData(pre,item) {
            const [ w, h ] = item.conf_resolution.split('*');
            // 获取宽度 高
            if (pre.resolution) {
                pre.resolution.push({
                    w, h
                })
            } else {
                pre.resolution = [ {w, h} ]
            }
            const size = {
                type: item.material_type,
                size: item.conf_size,
                format: item.conf_format
            };
            // 获取大小
            if (pre.size) {
                pre.size.push(size)
            } else {
                pre.size = [ size ]
            };
            return pre
        },
        async handleHttpRequest({ file }) {
            file.key = this.getKey();//身份标识
            file.noAllFileConfigList = cloneDeep(this.noAllFileConfigList)
            file.fileTypes = cloneDeep(this.fileTypes)
            file.videoData = cloneDeep(this.videoData)
            file.imageData = cloneDeep(this.imageData)
            this.fileList = [
                ...this.fileList,
                file
            ]
            // const type = file.type.split('/')[1];
            // 
            // console.log(media, type);
        },
        async validFile(file) {
            const fileTypes = file.fileTypes;
            const videoData = file.videoData;
            const imageData = file.imageData;
            const noAllFileConfigList = file.noAllFileConfigList;
            file.fileTypes = null;
            file.noAllFileConfigList = null;
            file.videoData = null;
            file.imageData = null;
            const type = file.type.split('/')[1];
            if (!fileTypes.includes(type)) {
                return Promise.reject({
                    name: file.name,
                    message: '素材格式不符合'
                })
            }
            const media  = await getMediaInfo(file);
            const { duration, fileSize, height, width  } = media;
            let resolutionList, sizeList;
            const TYPES = {
                V: '3',
                I: '1'
            }
            let fileType;
            if (media.format === 'MPEG-4') {
                const { 
                    time, resolution, size
                } = videoData;
                
                // 验证时间
                const timeResult = time.some(v=>duration<=v);
                if (!timeResult) {
                    return Promise.reject({
                        name: file.name,
                        message: '素材时长不符合'
                    })
                };
                resolutionList = resolution;
                sizeList = size;
                fileType = TYPES.V
               
            }else {
                const { 
                    resolution, size
                } = imageData;
                resolutionList = resolution;
                sizeList = size;
                fileType = TYPES.I
            };
            const resolutionResult = resolutionList.some(({ w, h })=> {
                return +height === +h && +width === +w
            });
             if (!resolutionResult) {
                return Promise.reject({
                    name: file.name,
                    message: '素材宽高不符合'
                })
            };
            const  oType = type; 
            const sizeResult = sizeList.some(v=> {
                const { type ,size, format } =v;
                 return type === fileType && +fileSize <= +size && (format.indexOf(oType)>-1)
            });
             if (!sizeResult) {
                return Promise.reject({
                    name: file.name,
                    message: '素材大小不符合'
                })
            };
            const configData = noAllFileConfigList.find(v=> {
                const [ w, h ] = v.conf_resolution.split('*');
                const type = v.material_type === '1'? TYPES.I : TYPES.V;
                return fileType  === type&& ( +height === +h && +width === +w )
            });
            const typeList = configData.conf_format.split('/');
            if (typeList.includes(type)) {
                // 很开心验证通过拉  去上传
                this.$emit('upload', file, {
                ...configData
                }, media)
            }else {
               return Promise.reject({
                    name: file.name,
                    message: '素材格式不符合'
                }) 
            }
        }
    },
    watch: {
         async fileList(n) {
            if (this.lock) {
                return
            }
            if (n.length) {
                this.lock = true
                const file = this.fileList.shift();
                try {
                    await this.validFile(file)
                } catch (error) {
                    console.log(error);
                    this.errFileList.push(error)
                }finally {
                    // 开锁后继续走校验
                    this.lock = false;
                    this.fileList = [ ...this.fileList ];
                }
            }else {
                this.lock = false
                if (!this.errFileList.length) {
                    return
                }
                const message = this.errFileList.map(v=> {
                    return `<p>${v.name}</p><span>${v.message}</span>`
                })
                this.$notify.error({
                    title: '错误',
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: message.join('')
                });
                this.errFileList = []
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
.upload ::v-deep {
    .el-upload,.el-upload-dragger {
        width: 100%;
    }
    .el-upload-dragger {
        height: auto;
        padding-bottom: 40px;
    }
} 

.upload-tip {
   font-size: 12px;
   color: #606266;
   .fiter-item {
    line-height: 40px;
   }
}
.cancel-btn {
    position: absolute;
    top: 6px;
    left: 220px;
    z-index: 9;
}
</style>